import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';


@Component({
  selector: 'app-press-release',
  templateUrl: './press-release.component.html',
  styleUrls: ['./press-release.component.css']
})
export class PressReleaseComponent implements OnInit {

  // heading = "Cyber Lab Services";
  // subheading = "Each data that is stored and used in Cyberspace is at risk. With the advent of rapid technology adoption, high is the cyber threats and attacks for many organizations. Protectt.ai Labs provide a cohesive and integrated approach to protect and safeguard business data";
  innerWidth:number = window.innerWidth;

  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta,  private canonicalService: CanonicalService) {
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/press-release");
   }

  ngOnInit(): void {
    this.titleService.setTitle("Protectt.ai's Mobile App Security Platform “AppProtectt” Recognized as winner of Banking Frontier Technoviti Award, 2023");
    this.metaTagService1.updateTag({name: 'title', content: "Protectt.ai's Mobile App Security Platform “AppProtectt” Recognized as winner of Banking Frontier Technoviti Award, 2023"});
    this.metaTagService.updateTag(
      { name: 'description', content: "Protectt.ai, a leading Mobile Threat Defence & cybersecurity company, is proud to announce that its flagship Mobile App Security platform “AppProtectt”" }
    );
    // og: tag
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.protectt.ai/assets/images/logo/cropped-logo-2.png', });
    this.metaTagService.updateTag({ property: 'og:description', content: "Protectt.ai, a leading Mobile Threat Defence & cybersecurity company, is proud to announce that its flagship Mobile App Security platform “AppProtectt”", });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.protectt.ai/press-release', });
    this.metaTagService.updateTag({ property: 'og:site_name', content: ' Protectt.ai ', });
    this.metaTagService.updateTag({ property: 'og:title', content: "Protectt.ai's Mobile App Security Platform “AppProtectt” Recognized as winner of Banking Frontier Technoviti Award, 2023", });
  }

}
